import { RefreshCcw } from "lucide-react";
import { Button } from "@components/ui/button";
import { updateVersionAndReload } from "@hooks/useVersionCheck";
import { cn } from "@shared-kernel/primary/shared/shadcn/utils/utils";

interface VersionToastProviderProps {
  children: React.ReactNode;
}

export function VersionToastProvider({ children }: VersionToastProviderProps) {
  return <div className="relative">{children}</div>;
}

interface VersionToastProps {
  className?: string;
}

export function VersionToast({ className }: VersionToastProps) {
  return (
    <div
      className={cn(
        "group pointer-events-auto relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-md border border-destructive bg-destructive p-6 pr-8 shadow-lg transition-all",
        className,
      )}
    >
      <div className="flex items-center gap-2">
        <p className="text-sm font-medium text-destructive-foreground">Une nouvelle version de l'application est disponible.</p>
        <Button
          variant="default"
          onClick={() => {
            updateVersionAndReload();
          }}
          className="h-12"
        >
          <RefreshCcw className="mr-2 size-4" />
          Actualiser la page
        </Button>
      </div>
    </div>
  );
}

interface VersionToastViewportProps {
  children: React.ReactNode;
}

export function VersionToastViewport({ children }: VersionToastViewportProps) {
  return (
    <div className="fixed left-0 top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:left-0 sm:top-0 sm:flex-col md:max-w-[420px]">
      {children}
    </div>
  );
}
